export default __webpack_public_path__ + "static/media/selenium.a00407a2.svg";